
import React from 'react'
import DashBody from '../../Layout/Dashboard/DashBody'
import DashHeader from '../../Layout/Dashboard/DashHeader'
import LyTable from '../../Layout/Dashboard/LyTable'
import useTableColumns from './useTableColumns'
import { QueryStatusEnum } from '../../config/QueryStatus'
import { useNavigate } from 'react-router-dom'
import AddButton from '../../Layout/Dashboard/AddButton/AddButton'
import { useGetKey } from '../../api/Key'
import SelectField from '../../Layout/Dashboard/SelectField'

function Page() {

    const column   =useTableColumns()
    const {data  ,status } = useGetKey()
    const navigate = useNavigate()
    const typeselect = [
      {label : "home" , value : "home"},
      {label : "setting" , value : "setting"},
      {label : "contact_us" , value : "contact_us"},
      {label : "about_us" , value : "about_us"}
  
  
    ]

        const ExpandedComponent = ({ data }:any) => {
      console.log(data,"data");
      
      return (
        <div className='p-2'>
          <p >value : {data?.value}</p>
        </div>
      );
    };
  return (
    // Pass Status to Layout 
    <DashBody status={status as QueryStatusEnum} >

      <DashHeader showAddButton={false} title={'key'}>
      <div className='RightSide d-flex gap-2 align-center '>
      <SelectField selectBy="type" lebel="type" option={typeselect} />

     {/* <AddButton  onClick={()=>navigate('/key/add')}></AddButton> */}

     </div>

      </DashHeader>

      
      <LyTable
        data={data?.data}
        isLoading={false}
        columns={column}
        is_pagination={false}
        expandableRows 
        expandableRowsComponent={ExpandedComponent}
    />
      
    
    </DashBody>
  )
}

export default Page

